const NO_HEADER_FALLBACK = 240;

function initCartFab(fab) {
  const count = fab.querySelector('[data-hd-cart-fab-count]');
  const header = document.querySelector('.site-header') || document.querySelector('header');
  const masthead = document.querySelector('.site-masthead__action--cart');

  let showAt = NO_HEADER_FALLBACK;

  const measure = () => {
    if (header) {
      showAt = Math.round(header.getBoundingClientRect().bottom + window.scrollY);
    }
  };

  const update = () => {
    fab.classList.toggle('is-visible', window.scrollY > showAt);
  };

  fab.hdCartFab = {
    measure,
    update,
    get showAt() {
      return showAt;
    },
  };

  measure();
  update();

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', () => {
    measure();
    update();
  });
  window.addEventListener('orientationchange', () => {
    measure();
    update();
  });
  window.addEventListener('load', () => {
    measure();
    update();
  });

  const render = (n) => {
    if (!count) return;
    const value = Number.isFinite(n) ? n : 0;
    count.textContent = String(value);
    count.hidden = value === 0;
  };

  const readMasthead = () => {
    const badge = document.querySelector('.site-masthead__cart-count');
    if (!badge) return false;
    const n = parseInt(badge.textContent || '', 10);
    if (!Number.isFinite(n)) return false;
    render(badge.hidden ? 0 : n);
    return true;
  };

  if (!readMasthead()) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (cart && typeof cart.item_count === 'number') render(cart.item_count);
      })
      .catch(() => {});
  }

  if (masthead && 'MutationObserver' in window) {
    new MutationObserver(readMasthead).observe(masthead, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['hidden'],
    });
  }
}

document.querySelectorAll('[data-hd-cart-fab]').forEach((el) => {
  if (el instanceof HTMLElement) initCartFab(el);
});
